import { render, staticRenderFns } from "./SpecificationGroup.vue?vue&type=template&id=d4c500b8"
import script from "./SpecificationGroup.vue?vue&type=script&lang=js"
export * from "./SpecificationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports